import { storeToRefs } from 'pinia';

import { useWarehouseStore } from '@/stores/useWarehouseStore';

export function useSelectedWarehouse() {
  const warehouseStore = useWarehouseStore();
  const {
    selectedWarehouse,
    selectedWarehouseId,
    selectedWarehouseTimezone,
    selectedWarehouseFeatures
  } = storeToRefs(warehouseStore);

  return {
    selectedWarehouse,
    selectedWarehouseId,
    selectedWarehouseTimezone,
    selectedWarehouseFeatures
  };
}
